<div class="min-h-screen flex items-center justify-center bg-white px-4">
  <div class="max-w-6xl w-full grid lg:grid-cols-2 items-center gap-32">
    
    <div>
      <h1 class="text-[32px] font-extrabold text-[#0A4E8F] mb-4">Vaya...</h1>
      <h2 class="text-2xl text-[#0A4E8F] font-bold mb-4">Página no encontrada</h2>
      <p class="text-[#272B34] text-base font-semibold mb-2 lg:whitespace-nowrap">
        Puede que el enlace esté roto o que la página haya sido movida. Te sugerimos que 
      </p>
      <p class="text-[#272B34] text-base font-semibold  mb-6">
        regreses a la página de inicio.
      </p>
      <app-button size="mediumLarge" text="Regresar a la página de inicio" [type]="'primary'" (click)="goToHome()"   (keydown.enter)="goToHome()"></app-button>
    </div>

    <div class="flex justify-center lg:ml-32">
      <picture>
        <source srcset="/not-found.webp" type="image/webp" />
        <img src="/not-found.jpg" alt="No encontrado" class="max-w-full h-auto" />
      </picture>
    </div>

  </div>
</div>
